// Small UID generator using the Web Crypto API when available.
export function generateUid(): string {
  // Prefer crypto.randomUUID() when available
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }

    // Fallback: use crypto.getRandomValues to produce 16 bytes and encode as hex
    if (typeof crypto !== 'undefined' && typeof crypto.getRandomValues === 'function') {
      const arr = new Uint8Array(16);
      crypto.getRandomValues(arr);
      return Array.from(arr).map(b => b.toString(16).padStart(2, '0')).join('');
    }
  } catch (e) {
    // If crypto exists but something unexpected happens, fall through to Math.random fallback
    console.info('generateUid: crypto operation failed, falling back to Math.random', e);
  }

  // Last-resort fallback (not cryptographically secure) — still OK for purely UI-local temporary IDs
  return 'uid_' + Math.random().toString(36).slice(2);
}

export default generateUid;
